var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcFingerprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.703,
    height: 160.674,
    viewBox: "0 0 137.703 160.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-finger-print",
    "data-name": "Icon ionic-md-finger-print",
    transform: "translate(-4.5 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5919",
    "data-name": "Path 5919",
    d: "M9.557,49.374a5.025,5.025,0,0,1-4.376-7.532c6.384-10.759,25.787-35.9,68.179-35.9,18.363,0,34.466,4.878,47.844,14.489a81.169,81.169,0,0,1,20.12,21.124A4.984,4.984,0,0,1,140,48.513a5.1,5.1,0,0,1-7.029-1.327c-5.344-7.747-21.555-31.274-59.607-31.274-37.156,0-53.941,21.662-59.428,30.951A4.951,4.951,0,0,1,9.557,49.374Z",
    transform: "translate(0 15.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5920",
    "data-name": "Path 5920",
    d: "M90.147,132.764a5,5,0,0,1-1.255-.143C58.156,124.91,46.679,93.851,46.213,92.56l-.072-.287c-.251-.9-6.42-22.2,3.049-34.681,4.34-5.7,10.939-8.608,19.654-8.608,8.105,0,13.951,2.546,17.968,7.819,3.3,4.3,4.627,9.612,5.918,14.74,2.69,10.652,4.627,16.247,15.816,16.821a11.551,11.551,0,0,0,9.97-5.129c4.949-6.743,5.81-17.753,2.08-27.437-4.806-12.553-21.806-36.188-51.789-36.188a52.579,52.579,0,0,0-34,11.979,55.2,55.2,0,0,0-17,25.034c-5.523,17.5,1.722,45.01,1.793,45.261a4.975,4.975,0,0,1-3.586,6.1,5.094,5.094,0,0,1-6.2-3.551c-.323-1.255-8.07-30.593-1.686-50.82C15.082,31.7,36.53,9.6,68.808,9.6a63.544,63.544,0,0,1,40.778,14.812c9.11,7.532,16.57,17.645,20.443,27.759,4.949,12.911,3.622,27.4-3.371,36.869-4.662,6.312-11.3,9.612-18.65,9.253C88.856,97.33,85.413,83.809,82.9,73.946,80.32,63.832,78.671,58.955,68.808,58.955c-5.416,0-9.217,1.506-11.584,4.627C54,67.849,53.745,74.52,54.1,79.362a51.506,51.506,0,0,0,1.686,9.97c.789,2.008,11.046,27.437,35.614,33.605A4.982,4.982,0,0,1,95.061,129,5.092,5.092,0,0,1,90.147,132.764Z",
    transform: "translate(4.553 30.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5921",
    "data-name": "Path 5921",
    d: "M35.34,115.014a5.106,5.106,0,0,1-3.694-1.578c-12.3-13.055-19.259-27.652-21.878-45.907v-.108C8.3,55.335,10.45,38.228,20.995,26.464c7.783-8.679,18.721-13.091,32.458-13.091,16.247,0,29.015,7.639,36.977,22.057a62,62,0,0,1,6.958,21.34,5.066,5.066,0,0,1-10.078,1.04h0a51.916,51.916,0,0,0-5.918-17.825C75.222,28.975,65.826,23.38,53.416,23.38c-10.724,0-19.116,3.264-24.89,9.719-8.321,9.289-9.935,23.6-8.787,33.067,2.3,16.139,8.428,28.979,19.259,40.455a4.961,4.961,0,0,1-.251,7.065A5.087,5.087,0,0,1,35.34,115.014Z",
    transform: "translate(19.908 45.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    "data-name": "Path 5922",
    d: "M60.661,68.034c-10.759,0-19.9-3.013-27.221-9-14.7-11.979-16.354-31.489-16.426-32.314a5.055,5.055,0,0,1,10.078-.789c.036.287,1.506,16.247,12.84,25.428,6.707,5.416,15.673,7.567,26.719,6.312a5.041,5.041,0,0,1,5.595,4.411A4.98,4.98,0,0,1,67.8,67.6,61.382,61.382,0,0,1,60.661,68.034Z",
    transform: "translate(51.254 78.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M105.22,13.225C101.023,10.463,86.14,2.25,58.165,2.25c-29.373,0-44.293,9.074-47.593,11.369a3.915,3.915,0,0,0-.61.466.111.111,0,0,1-.072.036h0a4.981,4.981,0,0,0,3.371,8.715A5.123,5.123,0,0,0,16.2,21.9h0l-.036.036c.143-.108,13.019-9.683,42-9.683s41.854,9.612,42,9.683l-.036-.036.072-.072a5.026,5.026,0,1,0,5.021-8.608Z",
    transform: "translate(15.195 0)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFingerprint);
export default __webpack_public_path__ + "static/media/ic_fingerprint.4b2dea1fa43f5f8d8178c1359e17bc3d.svg";
export { ForwardRef as ReactComponent };